module.exports = __webpack_public_path__ + "img/icon-trash-can.d5c2d165.svg";